import { gql, useQuery } from "@apollo/client";
import React, { useContext, useEffect } from "react";
import TagManager from "react-gtm-module";
import TrackVisibility from "react-on-screen";
import Slider from "react-slick";
import { PageContext } from "./../../context/PageContext";
import { SectionAbout } from "./SectionAbout";
import { SectionRoom } from "./SectionRoom";
import { SectionWhatsOn } from "./SectionWhatsOn";
import { SectionRewards } from "./SectionRewards";
import { SectionSendInfo } from "./SectionSendInfo";
import { SectionCover } from "./SectionCover";

const tagManagerArgs = {
  dataLayer: {
    userId: "001",
    userProject: "Union-Group",
    page: "Home",
  },
  dataLayerName: "PageDataLayer",
};
const GET_HOME = gql`
  query HomePage {
    page(id: "tug-home-navigation", idType: URI) {
      homePage {
        headline
        description
        brandsLogo {
          desktop {
            sourceUrl
            title
            altText
          }
          mobile {
            sourceUrl
            title
            altText
          }
        }
        middleBanner {
          description
          name
          order
          image {
            sourceUrl
            title
            altText
          }
        }
        topBanner {
          order
          image {
            sourceUrl
            title
            altText
          }
        }
      }
    }
  }
`;

const Home = () => {
  TagManager.dataLayer(tagManagerArgs);

  const { brand, common, sample, whatson, handleNavLoad, handlePageLoad } =
    useContext(PageContext);
  const images = { brand, common, sample, whatson };

  const { data } = useQuery(GET_HOME);
  const homeData = data?.page?.homePage;
  const topBanner = homeData?.topBanner
    ?.map((item) => item)
    .sort((a, b) => a?.order - b?.order);
  const headline = homeData?.headline;
  const description = homeData?.description;
  const brandsLogo = homeData?.brandsLogo;
  const middleBanner = homeData?.middleBanner
    ?.map((item) => item)
    .sort((a, b) => a?.order - b?.order);

  useEffect(() => {
    handleNavLoad(true);
    handlePageLoad("home");
  }, []);
  return (
    <>
      <SectionCover data={topBanner} />
      <SectionAbout
        images={images}
        description={description}
        headline={headline}
        logoDesktop={brandsLogo?.desktop?.sourceUrl}
        logoMobile={brandsLogo?.mobile?.sourceUrl}
      />
      <TrackVisibility once offset={100}>
        <SectionRoom images={images} data={middleBanner || []} />
      </TrackVisibility>
      <TrackVisibility once>
        {/* <SectionWhatsOn images={images} /> */}
      </TrackVisibility>
      <TrackVisibility once>
        <SectionRewards images={images} />
      </TrackVisibility>
      <a
        href="https://www.sevenrooms.com/explore/theuniongroup/reservations/create/search/?date=2025-05-31&venues=barluca%2Cbisteccapikavenue%2Cbistecca18parcplace%2Cbouchonjalansenopati%2Ccaffemilanograndindonesia%2Ccaffemilanopikavenue%2Ccorkscrewpacificplace%2Ccorkscrewplazaindonesia%2Ccorkscrewcountryclub%2Cloewy2Cpierre%2Cromapondokindah%2Cromasequistower%2Cunioncentralparkmall%2Cuniongrandindonesia%2Cunionmallkelapagading3%2Cunionpikavenue%2Cunionpakuwonmall%2Cunionplazasenayan%2Cunionpondokindah%2Cunionsenayancity%2Cunionsummareconmallserpong%2Cuniontunjunganplaza"
        target="_blank"
        className="btn btn-primary btn-book-now-mobile"
      >
        Book Now
      </a>
      <SectionSendInfo />
    </>
  );
};

export default Home;
